import { isProductFeatureEnabled } from "@/business/product-access";
import { useBusinessProducts } from "@/core/business/use-business-products";

/**
 * Whether this business processes sales receipts (the AP `receipts` product
 * feature, off unless chosen in admin). Off, the Receipts tab is hidden and
 * an emailed receipt is recognized but never extracted.
 */
export const useReceiptsEnabled = () => {
  const { settings } = useBusinessProducts();
  return isProductFeatureEnabled(settings, "accounts_payable", "receipts");
};
